import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  "Wenn es um Bartdesign geht, kann ich Nabil Barbershop nur empfehlen. Ich war an vielen Orten — aber so gut wie hier hat es keiner gemacht.",
  "Mein Stammfriseur. Egal ob Haar oder Bart — Nabil überzeugt mit Handwerk und seiner immer freundlichen Art.",
  "Der beste Barber den ich kenne. Beeindruckend wie genau und gleichmäßig er schneiden kann.",
];

export default function Reviews() {
  return (
    <section className="py-28 lg:py-36" style={{ background: "#080808" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="pre-headline mb-6">
          Bewertungen
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl mb-16"
          data-testid="reviews-headline"
        >
          Was unsere <span className="gold-text">Kunden</span> sagen.
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((text, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="p-8 lg:p-10 flex flex-col"
              style={{ background: "#181818", border: "1px solid rgba(201,168,76,0.12)" }}
              data-testid={`review-card-${i}`}
            >
              <span className="quote-mark">“</span>
              <p className="font-display italic text-base leading-relaxed flex-1 -mt-6" style={{ color: "#F5F0E8" }}>
                {text}
              </p>
              <div className="mt-8 flex items-center gap-1">
                {[...Array(5)].map((_, s) => (
                  <motion.span
                    key={s}
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: 0.3 + i * 0.15 + s * 0.05 }}
                  >
                    <Star size={16} fill="#C9A84C" stroke="#C9A84C" />
                  </motion.span>
                ))}
                <span className="ml-3 text-xs" style={{ color: "#999999" }}>— Google Review</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
